import React from 'react';

import SmartMailFrontDeskList from './components/SmartMailFrontDeskList';

const SmartMailFrontDesk = () => <SmartMailFrontDeskList />;

export default SmartMailFrontDesk;
